import gql from 'graphql-tag'

export default gql`query pcpGetGroups($name: String, $limit: Int) {
	pcpGetGroups(name: $name, limit: $limit) {
		deleted
		id
		name
  }
}`
